export const FETCH_PATIENT_PROFILE = 'src/ReferrerPatientView/FETCH_PATIENT_PROFILE';
export const FETCH_PATIENT_PROFILE_SUCCESS = 'src/ReferrerPatientView/FETCH_PATIENT_PROFILE_SUCCESS';
export const FETCH_PATIENT_PROFILE_ERROR = 'src/ReferrerPatientView/FETCH_PATIENT_PROFILE_ERROR';

export const FETCH_PATIENT_CALENDAR = 'src/ReferrerPatientView/FETCH_PATIENT_CALENDAR';
export const FETCH_PATIENT_CALENDAR_SUCCESS = 'src/ReferrerPatientView/FETCH_PATIENT_CALENDAR_SUCCESS';
export const FETCH_PATIENT_CALENDAR_ERROR = 'src/ReferrerPatientView/FETCH_PATIENT_CALENDAR_ERROR';

export const FETCH_PATIENT_GROUPS = 'src/ReferrerPatientView/FETCH_PATIENT_GROUPS';
export const FETCH_PATIENT_GROUPS_SUCCESS = 'src/ReferrerPatientView/FETCH_PATIENT_GROUPS_SUCCESS';
export const FETCH_PATIENT_GROUPS_ERROR = 'src/ReferrerPatientView/FETCH_PATIENT_GROUPS_ERROR';

export const FETCH_PATIENT_OQ = 'src/ReferrerPatientView/FETCH_PATIENT_OQ';
export const FETCH_PATIENT_OQ_SUCCESS = 'src/ReferrerPatientView/FETCH_PATIENT_OQ_SUCCESS';
export const FETCH_PATIENT_OQ_ERROR = 'src/ReferrerPatientView/FETCH_PATIENT_OQ_ERROR';
